import { rankWith, uiTypeIs } from '@jsonforms/core'
import { ADVICE_RENDERER_META } from './AdviceRender'

export default rankWith(3, uiTypeIs(ADVICE_RENDERER_META.type))
